import React from 'react'
import { string } from 'prop-types'
import { MediaIframeEmbed } from '../MediaIframeEmbed'

export const Twitch = ({ channel, ...rest }) => {
  if (!channel) return null
  return (
    <MediaIframeEmbed
      src={`https://player.twitch.tv/?channel=${channel}&parent=${window.location.hostname}`}
      {...rest}
    />
  )
}

Twitch.propTypes = {
  channel: string,
}
